import { GESTURE_CANCEL_MOVE_PX } from './pointer-drag-reorder.js';

const PRESSED_CLASS = 'is-pressed';
const GUARD_CLASS = 'no-press-feedback';
const ENABLED_PROPERTY = '--press-feedback-enabled';
const SHELL_SELECTOR = '.data-grid-mobile-pill.press-feedback, .data-grid-item > .data-grid-row.press-feedback';
const INTERACTIVE_SELECTOR = 'button, a, input, select, textarea, label, .stack-btn';

let activePointerId = null;
let pressedElement = null;
let guardedShell = null;
let pressOrigin = null;

function supportsNonInheritedMarker() {
    return typeof CSS !== 'undefined' && typeof CSS.registerProperty === 'function';
}

function findPressable(element) {
    let node = element;
    while (node && node !== document.body) {
        if (getComputedStyle(node).getPropertyValue(ENABLED_PROPERTY).trim() === '1') {
            return node;
        }
        node = node.parentElement;
    }
    return null;
}

function releasePress() {
    activePointerId = null;
    pressOrigin = null;
    if (pressedElement) {
        pressedElement.classList.remove(PRESSED_CLASS);
        pressedElement = null;
    }
    if (guardedShell) {
        guardedShell.classList.remove(GUARD_CLASS);
        guardedShell = null;
    }
}

function releaseOwnedPointer(event) {
    if (event.pointerId === activePointerId) {
        releasePress();
    }
}

function guardShellOf(interactive) {
    const shell = interactive.closest(SHELL_SELECTOR);
    if (!shell || shell === interactive || shell.classList.contains(GUARD_CLASS)) {
        return;
    }
    shell.classList.add(GUARD_CLASS);
    guardedShell = shell;
}

function onPointerDown(event) {
    if (event.button !== 0 || !event.isPrimary) {
        return;
    }
    releasePress();
    const target = event.target;
    if (!(target instanceof Element)) {
        return;
    }
    const interactive = target.closest(INTERACTIVE_SELECTOR);
    if (interactive) {
        guardShellOf(interactive);
    }
    const pressable = findPressable(target);
    if (!pressable || pressable.classList.contains(GUARD_CLASS)) {
        return;
    }
    pressable.classList.add(PRESSED_CLASS);
    pressedElement = pressable;
    activePointerId = event.pointerId;
    pressOrigin = { x: event.clientX, y: event.clientY };
}

function onDragStart(event) {
    releasePress();
    const target = event.target;
    if (!(target instanceof Element) || target.closest('[draggable="true"]')) {
        return;
    }
    if (findPressable(target)) {
        event.preventDefault();
    }
}

function onPointerMove(event) {
    if (!pressOrigin || event.pointerId !== activePointerId) {
        return;
    }
    if (event.buttons === 0) {
        releasePress();
        return;
    }
    const travelled = Math.hypot(event.clientX - pressOrigin.x, event.clientY - pressOrigin.y);
    if (travelled > GESTURE_CANCEL_MOVE_PX) {
        releasePress();
    }
}

if (supportsNonInheritedMarker()) {
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('pointermove', onPointerMove, true);
    document.addEventListener('pointerup', releaseOwnedPointer, true);
    document.addEventListener('pointercancel', releaseOwnedPointer, true);
    document.addEventListener('dragstart', onDragStart, true);
    document.addEventListener('contextmenu', releasePress, true);
    window.addEventListener('blur', releasePress);
}
